export default __webpack_public_path__ + "static/media/login-image.ca4d9323.jpg";